<template>
  <div class="card card-table flex-fill">
    <div class="card-header">
      <h3 class="card-title mb-0">Post Terakhir</h3>
    </div>
    <div class="card-body">
      <div class="table-responsive">
        <table class="table custom-table mb-0">
          <thead>
            <tr>
              <th>Judul</th>
              <th class="text-center">Gambar</th>
              <th>Deskripsi</th>
            </tr>
          </thead>
          <tbody>
            <template v-if="loading">
              <tr>
                <td colspan="3">
                  <Skeleton :count="1" />
                </td>
              </tr>
            </template>
            <template v-if="rows.length > 0">
              <tr v-for="(row, index) in rows" :key="index">
                <td class="text-wrap">{{ row.title }}</td>
                <td class="text-wrap text-center" :ref="'marketplace-' + row.id">
                  <img :src="JSON.parse(row.assets_url)[0]" style="width:100%;" :alt="row.title">
                </td>
                <td class="text-wrap" :ref="'keywords-' + row.id">
                  <div class="text-muted">{{row.caption.substr(0,100)}}</div>
                </td>
              </tr>
            </template>
            <template v-if="rows.length <= 0 && !loading">
              <tr>
                <td colspan="3" class="text-center">Tidak ada data yang tersedia</td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
    </div>
    <div class="card-footer">
      <router-link :to="{ name: 'instagram_post_schedule' }"
        >Lihat Semua Post Instagram</router-link
      >
    </div>
  </div>
</template>

<script>
import { Skeleton } from "vue-loading-skeleton";
import { marketplaceIcon } from "@/utils/helper";

export default {
  data() {
    return {
      licenseArr: [],
      licenseArrLoading: false,
      taskLoading: false,
      taskTotalRecords: 0,
      taskRows: [],
      taskParams: {
        columnFilters: {
          license_id: "",
          agent_id: "",
          is_resolved: "0"
        },
        page: 1,
        perPage: 20 // perPage
      },
      loading: false,
      currentPage: 1,
      rows: [],
      totalRecords: 0,
      serverParams: {
        page: 1,
        perPage: 10
      }
    };
  },
  components: {
    Skeleton
  },
  created() {
    this.loadItems();
  },
  methods: {
    async loadItems() {
      this.loading = await true;
      this.serverParams.page =
        this.serverParams.page - 1 <= 0
          ? await 0
          : await ((this.serverParams.page - 1) * this.serverParams.perPage);

      await this.$store
        .dispatch("instagramSchedule/listSchedule", this.serverParams) // sesuai kan dengan method di API
        .then(response => {
          const { data } = response;
          this.totalRecords = data.totalRecords;
          this.rowPage = data.page;
          this.rows = data.data;
          this.loading = false;
        })
        .catch(error => {
          console.log(error);
          this.loading = false
        });
    },
    marketplaceIcon(value){
        return marketplaceIcon(value)
    }
  },
  mounted() {
    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function(e) {
          $(this)
            .parents(".form-focus")
            .toggleClass(
              "focused",
              e.type === "focus" || this.value.length > 0
            );
        })
        .trigger("blur");
    }
  },
  name: "employeedashboard"
};
</script>



// WEBPACK FOOTER //
// src/views/dashboard/components/lastPost.vue